import React, { useEffect, useState } from 'react';
import styles from './style.module.css';
import { BackPage, Forms } from 'components';
import { useHistory } from 'react-router-dom';

const AddNewCard = () => {
  const history = useHistory();
  const [formReady, setFormReady] = useState(false);

  useEffect(() => {
    setFormReady(true);
  }, []);

  return (
    <BackPage onBackClick={() => history.goBack()}>
      <h2 className={styles.header}>Add a card</h2>
      {formReady && <Forms.AddNewCheckoutCardForm />}
    </BackPage>
  );
};

export default AddNewCard;
